export class ListItem {
    ID: string;
    parent_ID: any;
    text: string;
    value: string;
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/list-item.model.ts